import React, { memo, useState, useCallback, useEffect } from 'react';
import { GoogleMap, Data, Marker } from '@react-google-maps/api';

const containerStyle = {
  height: '200px',
};

const dataOptions = {
  clickable: false,
  draggable: false,
  editable: false,
  fillColor: '#F05',
  fillOpacity: 1,
  strokeColor: '#00FF55',
  strokeOpacity: 1,
  strokeWeight: 2,
  title: 'Title',
  visible: true,
  zIndex: 2000,
};

const LocationMap = (props) => {
  const [initialViewPoint, setInitialViewPoint] = useState(1);
  const [, setMap] = useState(null);
  const center = {
    lat: props.lat ? Number(props.lat) : 40.6976701,
    lng: props.lng ? Number(props.lng) : -74.2598667,
  };

  const onLoad = useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds();
    map.fitBounds(bounds);
    setMap(map);
  }, []);

  const onUnmount = useCallback(function callback(map) {
    setMap(null);
  }, []);

  // A hack to re-render the map and display the marker based on selected lat / long values.
  useEffect(() => {
    if (initialViewPoint === 1) {
      setTimeout(() => {
        setInitialViewPoint(10);
      }, 200);
    }
  }, [initialViewPoint]);

  return (
    <GoogleMap
      id='hotel-loc'
      mapContainerStyle={containerStyle}
      center={center}
      zoom={initialViewPoint}
      onLoad={onLoad}
      onUnmount={onUnmount}
      options={{ streetViewControl: false }}
    >
      <Data options={dataOptions} />
      {props.lat && props.lng && <Marker position={{ lat: center.lat, lng: center.lng }} />}
    </GoogleMap>
  );
};

export default memo(LocationMap);
